<template>
  <div class="auth">
    <div class="auth-container">
      <div class="card">
        <header class="auth-header">
          <h1 class="auth-title">
            <img src="/static/logo-login.png" alt="Volta Analytics" />
          </h1>
        </header>
        <div class="auth-content">
          <form id="login-form" v-on:submit.prevent="send">
            <div class="form-group">
              <input
                type="text"
                v-model="username"
                class="form-control"
                name="username"
                id="username"
                placeholder="Inserisci il tuo username"
                required
              />
            </div>

            <p class="alert alert-warning" v-if="message">
              {{ message }}
            </p>

            <div class="form-group">
              <button type="submit" class="btn btn-block btn-primary">
                <font-awesome-icon class="fa-spin" icon="spinner" v-if="loading" />
                <span v-if="!loading">Reset password</span>
              </button>
            </div>
          </form>
          <div>
            <router-link to="/login">Torna alla login</router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "LostPassword",
  data() {
    return {
      username: "",
      message: "",
    };
  },
  computed: {
    loading() {
      return this.$store.state.pending;
    },
  },
  methods: {
    send() {
      if (!this.username) return;

      const redirectUrl = `${window.location.origin}/#/password-reset`;
      this.$store
        .dispatch("users/resetPassword", {
          username: this.username,
          redirectUrl,
        })
        .then((res) => {
          if (res.code == 1)
            this.message = "Abbiamo inviato le istruzioni per il reset della password all'indirizzo specificato";
          else this.message = "Username non riconosciuto";
        });
    },
  },
};
</script>
<style scoped>
.logo img {
  height: 30px;
}
.auth {
  background: url("/static/bg.jpg") center center;
  background-size: cover;
}
.auth-title img {
  width: 300px;
}
.card {
  background: transparent;
  -webkit-box-shadow: none;
  box-shadow: none;
}
.card input[type="text"],
.card input[type="password"] {
  background: transparent;
  color: #fff;
}
.form-control.no-border {
  border: 0;
}
#username {
  border: 1px solid #fff;
}
</style>



// WEBPACK FOOTER //
// src/components/LostPassword.vue